import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { MessageCircle } from "lucide-react";
import CatalogView from "../components/factory/CatalogView";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicCatalog() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/catalog/${token}`).then((r) => setData(r.data)).catch(() => setError(true));
  }, [token]);

  useEffect(() => { if (data?.company_name) document.title = `${data.company_name} · ${data.config?.title || "Catálogo"}`; }, [data]);

  if (error) return <div className="min-h-screen flex items-center justify-center text-gray-600" data-testid="public-catalog-error">Catálogo não disponível.</div>;
  if (!data) return <div className="min-h-screen flex items-center justify-center text-gray-500">Carregando catálogo...</div>;

  const wa = (data.config?.whatsapp || "").replace(/\D/g, "");
  return (
    <div className="min-h-screen bg-gray-100 pt-4 pb-28" data-testid="public-catalog-page">
      <div className="max-w-[900px] mx-auto shadow-lg rounded-2xl overflow-hidden">
        <CatalogView data={data} freight={{ value: 0, note: data.config?.public_freight_note }} />
      </div>
      {wa && (
        <a
          href={`https://wa.me/${wa.length <= 11 ? "55" + wa : wa}?text=${encodeURIComponent("Olá! Vi o catálogo e gostaria de fazer um pedido.")}`}
          target="_blank" rel="noreferrer"
          className="fixed bottom-5 right-5 flex items-center gap-2 rounded-full bg-green-600 text-white px-5 py-3 font-bold shadow-xl hover:bg-green-700 transition-colors"
          data-testid="public-catalog-whatsapp"
        >
          <MessageCircle className="h-5 w-5" /> Pedir pelo WhatsApp
        </a>
      )}
    </div>
  );
}
